import classes from "./SkillUnit.module.css";

const SkillUnit = (props) => {
  const percent=(props.skillPercent*360/100)/2
  const value=percent+"deg"

  const progressBarStyles = {
    "--progress-value":value
  };


  return (
    <>
     
      <div className={classes.skillUnit}>
       
         
     <div className={classes['circle-wrap']} >
        <div className={classes.circle} >
        <div className={classes.mask + ' ' + classes.full}style={progressBarStyles}>
            <div className={classes.fill} style={progressBarStyles}></div>
          </div>
          <div className={classes.mask+ ' ' + classes.full}>
            <div className={classes.fill} style={progressBarStyles}></div>
          </div>
          <div className={classes['inside-circle']}> {props.skillPercent}%</div>
        </div>
      </div>
      <div className={classes.uppercontainer}>
          <span>{props.skillname}</span>
          {/* <span>{props.skillPercent}%</span> */}
        </div>

      </div>
   
    </>
  );
};

export default SkillUnit;
